import { createApp } from 'vue'
import Antd from 'ant-design-vue'
// import PerfectScrollbar from 'vue3-perfect-scrollbar'
import PerfectScrollbar from 'vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.esm'

import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import { i18n } from './localization'
//import './services/axios/fakeApi' // mocking api
import './services/axios/intranet'
//import axios from 'axios'


createApp(App)
    .use(store)
    .use(router)
    .use(i18n)
    .use(Antd)
    //.use(axios)
    .use(PerfectScrollbar)
    .mount('#app')
